var addEvent = function(e, t, n) {
    if (e == null || e == undefined) return;
    if (e.addEventListener) {
        e.addEventListener(t, n, false)
    } else if (e.attachEvent) {
        e.attachEvent("on" + t, n)
    }
};
var removeEvent = function(elem, type, eventHandle) {
    if (elem == null || elem == undefined) return;
    if (elem.removeEventListener) {
        elem.removeEventListener(type, eventHandle, false);
    } else if (elem.attachEvent) {
        elem.detachEvent("on" + type, eventHandle);
    }
};
var waitForFinalEvent = (function() {
    var timers = {};
    return function(callback, ms, uniqueId) {
        if (!uniqueId) {
            uniqueId = "Don't call this twice without a uniqueId";
        }
        if (timers[uniqueId]) {
            clearTimeout(timers[uniqueId]);
        }
        timers[uniqueId] = setTimeout(callback, ms);
    };
})();

addEvent(window, "load", function (){
    navigationMenu();
});
addEvent(window, "resize", function() {
    /*waitForFinalEvent(function(){
        alert('Resize...');
        //...
    }, 500, "some unique string");*/
});

if($(".form-top-page").length>0) {
    $(".form-top-page form").validate({
        rules: {
            first_name: {
                required: true
            },
            last_name: {
                required: true
            },
            email: {
                email: true
            },
            privacy: {
                required: true
            },
        }
    });
    $(".content-form-contact form").validate({
        rules: {

        }
    });
}

if($(".login-content").length>0) {
    $(".login-form form").validate({
        rules: {}
    });

    $(".register-form form").validate({
        rules: {
            type_user: {
                required: true
            },
            company_name: {
                required: "#type_user_c:checked"
            },
            password: {
                required: true,
                minlength: 8
            },
            password_confirmation: {
                equalTo: "#password",
                minlength: 8
            },
        }
    });
}

$(window).scroll(function() {
    if ($(this).scrollTop() > 50) {
        $('header').addClass('scrolled');
    }else{
        $('header').removeClass('scrolled');
    }
    if ($(this).scrollTop() > 350) {
        $('.scroll-top').fadeIn();
    }else{
        $('.scroll-top').fadeOut();
    }
});


$('.scroll-top').click(function (e) {
    e.preventDefault();
    $("html, body").animate({scrollTop:0}, 'slow');
})
$('.fakeAddProduct').click(function (e) {
    e.preventDefault();
    $('#must-login-top').addClass('deviFareLogin');
    setTimeout(function(){
        $('#must-login-top').removeClass('deviFareLogin');
    }, 7000);
})

$('.hamburger').click(function() {
    $(this).toggleClass("is-active");
    $('.content-submenu').toggleClass("open");
});

if($("#info-msg").length>0) {
    $('#info-msg').show(function () {
        $(".chiudi").click(function(e){
            e.preventDefault();
            $('#info-msg').hide();
            $('.overlay-popup').hide();
        })
    });
}

if($('.owl-carousel').length>0) {
    $('.list-partners').owlCarousel({
        margin: 20,
        responsiveClass: true,
        loop: true,
        slideSpeed: 700,
        paginationSpeed: 700,
        rewindSpeed: 700,
        lazyLoad: true,
        autoplay:true,
        autoplayTimeout:2000,
        nav: false,
        dots:false,
        responsive: {
            0: {
                items: 1,
                nav: false,
                dots:false
            },
            600: {
                items: 3,
                nav: false,
                dots:false
            },
            1024: {
                items: 4,
                nav: false,
                dots:false
            },
            1280: {
                items: 5
            }
        }
    });
    $('.list-other-product').owlCarousel({
        margin: 20,
        responsiveClass: true,
        loop: true,
        slideSpeed: 700,
        paginationSpeed: 2700,
        rewindSpeed: 700,
        lazyLoad: true,
        autoplay:false,
        autoplayTimeout:4000,
        nav: true,
        dots:false,
        responsive: {
            0: {
                items: 1,
                nav: false,
                dots:true
            },
            600: {
                items: 2,
                nav: false,
                dots:true
            },
            1024: {
                items: 3,
                nav: false,
                dots:true
            },
            1280: {
                items: 4
            }
        }
    });
    $('.list-news').owlCarousel({
        margin: 10,
        responsiveClass: true,
        loop: false,
        items:1,
        slideSpeed: 700,
        paginationSpeed: 700,
        lazyLoad: true,
        dots: true
    });
}

function navigationMenu(){
    if($('.home').length>0) {
        $('.goToPos').click(function (e) {
            $('.hamburger').trigger('click');
            e.preventDefault();
            var href = $(this).attr("href");
            var hash = href.substr(href.indexOf("#"));
            $('html, body').animate({
                scrollTop: $(hash).offset().top - $('header').innerHeight()
            }, 2000);
        });

        $('.goToSection').click(function (e) {
            e.preventDefault();
            var href = $(this).attr("href");
            var hash = href.substr(href.indexOf("#"));
            $('html, body').animate({
                scrollTop: $(hash).offset().top - $('header').innerHeight()
            }, 2000);
        });

        if (location.hash) {
            /*setTimeout(function() {
                window.scrollTo(0, 0);
            }, 0);*/

            $('html, body').animate({
                scrollTop: $(location.hash).offset().top - $('header').innerHeight()
            }, 2000);
        }
    }
}
